import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";
import store from "@/store/index";
import { CHECK_AUTH } from "@/store/actions.type";
import { FETCH_SESSIONLESS_APP_BY_APP_TYPE } from "@/store/actions.type";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        title: 'Accueil - COINNOV Fonds RDI'
      },
      children: [
        {
          name: "home",
          path: "",
          meta: {
            title: 'Accueil - COINNOV Fonds RDI'
          },
          component: () => import("@/views/applications")
        },
        {
            name: "homeCandidature",
            path: "/home/:app_id",
            meta: {
                title: 'Accueil - COINNOV Fonds RDI'
            },
            component: () => import("@/views/candidat")
        },
        {
          name: "FormCriteria",
          path: "/form-criteria/:app_id",
          meta: {
            title: 'Soumissionnaire - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/FormCriteria")
        },
        {
          name: "FormInnovations",
          path: "/form-innovations/:app_id",
          meta: {
            title: 'Projet - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/FormInnovations")
        },
        {
          name: "StartupInformationsForm",
          path: "/startup-informations/:app_id",
          meta: {
            title: 'Informations Startup - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/StartupInformationsForm")
        },
        {
          name: "FormChecklist",
          path: "/checklist/:app_id",
          meta: {
            title: 'Checklist - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/Checklist")
        },
        {
          name: "teams",
          path: "/teams/:app_id",
          meta: {
            title: 'Equipe - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Teams/teamsList")
        },
        {
          name: "team-add",
          path: "/add-team",
          meta: {
            title: 'Ajouter un membre - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Teams/teamAdd")
        },
        {
          name: "team-edit",
          path: "/team/:app_id/edit/:team_id",
          meta: {
            title: 'Responsable juridique - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Teams/TeamEdit")
        },
        {
          name: "team-delete",
          path: "/team/:app_id/delete/:team_id",
          meta: {
            title: 'Supprimer un membre - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Teams/teamDelete")
        },
        {
          name: "payment",
          path: "/payment/:app_id",
          meta: {
            title: 'Paiement - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Payment/payment")
        },
        {
          name: "Status",
          path: "/status/:app_id",
          meta: {
            title: 'Etat - COINNOV Fonds RDI'
          },
          component: () => import("@/views/feedback")
        },
        {
          name: "Label",
          path: "/label/:app_id",
          meta: {
            title: 'Label - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Label/label")
        },
        {
          name: "Avantages",
          path: "/avantages/:app_id",
          meta: {
            title: 'Avantages - COINNOV Fonds RDI'
          },
          props: {isStandardAdvantage: true},
          component: () => import("@/views/Label/avantages")
        },
        {
          name: "Financement",
          path: "/financement/:app_id",
          meta: {
            title: 'Financement - COINNOV Fonds RDI'
          },
          props: {isStandardAdvantage: false},
          component: () => import("@/views/Label/avantages")
        },

        // Déclarations 
        {
          name: "Declarations",
          path: "/declarations/:appType/:app_id",
          meta: {
            title: 'Déclarations - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Label/declarations")
        },
        // Detail declaration request
        {
          name: "DeclarationRequest",
          path: "/declaration-details/:appType/:formName/:declarationId",
          meta: {
            title: 'Declaration details - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Label/declarationRequest")
        },
         // Update form declaration request
        {
          name: "DeclarationEdit",
          path: "/declaration/:appType/:formName/:declarationId/edit",
          meta: {
            title: 'Modifier une déclaration - Startup'
          },
          component: () => import("@/views/Label/declarationEdit")
        },
        {
            name: "Entreprise",
            path: "/entreprise/:app_id",
            meta: {
                title: 'Entreprise - COINNOV Fonds RDI'
            },
            component: () => import("@/views/Label/CompanyEdit")
        },
        {
          name: "requestFrom",
          path: "/request-form/:ref/:type_id",
          meta: {
            title: 'Demande - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Label/request")
        },
        {
          name: "declarationForm",
          path: "/declaration-form/:appType/:formName/:ecoAppId/:id?",
          meta: {
            title: 'Déclaration - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/DeclarationForm")
        },
        {
          name: "requestFundingFrom",
          path: "/request-form/:ref/:type_id",
          meta: {
            title: 'Demande - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Label/FundingRequest")
        },
        {
            name: "requestLabel",
            path: "/request-label/:type_id",
            meta: {
                title: 'Demande label - COINNOV Fonds RDI'
            },
            component: () => import("@/views/Label/request")
        },
        {
          name: "StartupRequest",
          path: "/startup-request/:code_label/:id/:request_id",
          meta: {
            title: 'Request - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Label/startupRequest")
        },
        {
          name: "Prelabel",
          path: "/startup-request/:id/:appHash",
          meta: {
            title: 'Prélabel - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Label/startupRequest")
        },
        {
          name: "PrelabelEdit",
          path: "/startup-request/:id",
          meta: {
            title: 'Modifier une demande Prélabel - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Label/startupRequestEdit")
        },
        {
          name: "StartupRequestEdit",
          path: "/request-form/:code_label/:id/:request_id",
          meta: {
            title: 'Modifier une demande - Startup'
          },
          component: () => import("@/views/Label/startupRequestEdit")
        },
        {
          name: "StartupFundingRequest",
          path: "/startup-request/:code_label/:id/:request_id",
          meta: {
            title: 'Request - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Label/StartupFundingRequest")
        },
        {
          name: "FormBuilderTest",
          path: "/form-builder-test",
          meta: {
            title: 'Form Builder Test - COINNOV Fonds RDI'
          },
          props: {isStandardAdvantage: false},
          component: () => import("@/views/Label/request")
        },
        //******************//
        //*Investor Demandes Route*//
        //******************//
        {
          name: "sessionlessDeclaration",
          path: "/damandes/:appType/:app_id",
          meta: {
            title: 'Déclarations - COINNOV Fonds RDI'
          },
          component: () => import("@/views/SessionlessApplications/sessionlessDeclaration")
        },
        //******************//
        //*Ecosystem Routes*//
        //******************//
        {
          name: "StructureAndOrganization",
          path: "/:appType/:formName/:ecoAppId",
          meta: {
            title: 'Structure et organisation - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/EcosystemForm")
        },
        {
          name: "GeneralInfosAir",
          path: "/:appType/:formName/:ecoAppId",
          meta: {
            title: 'Informations Générales Air - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/EcosystemForm")
        },
        {
          name: "Air",
          path: "/:appType/:formName/:ecoAppId",
          meta: {
            title: 'Air - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/EcosystemForm")
        },
        {
          name: "AnteriorPrograms",
          path: "/:appType/:formName/:ecoAppId",
          meta: {
            title: 'Programmes passés - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/EcosystemForm")
        },
        {
          name: "DealForm",
          path: "/:appType/:formName/:ecoAppId",
          meta: {
            title: 'Formulaire DEAL - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/EcosystemForm")
        },
        {
          name: "SailForm",
          path: "/:appType/:formName/:ecoAppId",
          meta: {
            title: 'Formulaire SAIL - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/EcosystemForm")
        },
        {
          name: "GeneralInfosAir2",
          path: "/:appType/:formName/:ecoAppId",
          meta: {
            title: 'Informations Générales Air² - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/EcosystemForm")
        },
        {
          name: "Air2",
          path: "/:appType/:formName/:ecoAppId",
          meta: {
            title: 'Air² - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/EcosystemForm")
        },
        {
          name: "GeneralInfosD4d",
          path: "/:appType/:formName/:ecoAppId",
          meta: {
            title: 'Informations Générales D4D - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/EcosystemForm")
        },
        {
          name: "FundingRequirements",
          path: "/:appType/:formName/:ecoAppId",
          meta: {
            title: 'Besoins en financement - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Form/EcosystemForm")
        },
        {
          name: "EcoTeam",
          path: "/team/:app_id",
          meta: {
            title: 'Equipe fondatrice - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Ecosystem/Team")
        },
        {
          name: "BuilderForm",
          path: "/form-builder/:id",
          meta: { 
            title: "Form Builder Preview - COINNOV Fonds RDI"   
          },
          component: () => import("@/views//Form/EcosystemForm")
        },
        //******************//
        //*Investor Routes*//
        //******************//
        {
          name: "InvestorForm",
          path: "/:appType/:formName/:ecoAppId",
          meta: {
            title: 'Investisseur - COINNOV Fonds RDI'
          },
          component: () => import("@/views/SessionlessApplications/Form")
        },
        {
          name: "InvestorFormPrincipal",
          path: "/investor/:ecoAppId?",
          meta: {
            title: 'Investisseur - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Investor/Form")
        },
        {
          name: "InvestorCertificate",
          path: "/certificate/:ecoAppId",
          meta: {
            title: 'Attestation investisseur - COINNOV Fonds RDI'
          },
          component: () => import("@/views/Investor/Certificate")
        },
        // Investor Déclarations 
      ]
    },
    {
      name: "login-default",
      path: "/",
      meta: {
        layout: "no-sidebar",
        title: 'Login - COINNOV Fonds RDI'
      },
      component: () => import("@/views/Auth/Login")
    },
    {
      name: "login",
      path: "/login/:codeInvit?",
      meta: { 
        layout: "no-sidebar",
        title: 'Login - COINNOV Fonds RDI'
     },
      component: () => import("@/views/Auth/Login")
    },
    {
      name: "logout",
      path: "/logout",
      meta: { 
        layout: "no-sidebar",
        title: 'Déconnexion - COINNOV Fonds RDI' 
      },
      component: () => import("@/views/Auth/logout")
    },
    {
      name: "register",
      path: "/register/:codeInvit?",
      meta: { 
        layout: "no-sidebar" ,
        title: 'Création de compte - COINNOV Fonds RDI' 
      },
      component: () => import("@/views/Auth/Register")
    },
    {
      name: "ForgotPassword",
      path: "/forgot_password",
      meta: { 
        layout: "no-sidebar",
        title: 'Mot de passe oublié - COINNOV Fonds RDI'  
      },
      component: () => import("@/views/Auth/ForgotPassword")
    },
    {
      name: "ResetPassword",
      path: "/reset_password/:token",
      meta: { 
        layout: "no-sidebar",
        title: 'Réinitialiser le mot de passe- COINNOV Fonds RDI'   
      },
      component: () => import("@/views/Auth/ResetPassword")
    },
    {
      name: "VERIFYUSER",
      path: "/verify/:token/:codeInvit?",
      meta: { 
        layout: "no-sidebar",
        title: "Vérifier l'utilisateur - COINNOV Fonds RDI"   
      },
      component: () => import("@/views/Auth/VerifUser")
    },
    // otherwise redirect to home
    { path: "*", redirect: "/", 
      meta: { 
        title: 'Startup Tunisia'   
      } 
  }
  ]
});
router.beforeEach(async (to, from, next) => {
  let applications = null;
  let currentUser = null;
  let matchedApplication = null;
  let currentApp = null;
  let application = null;
  if (['/home', '/', '/home/'].includes(to.path)) {
    const userRole = await store.dispatch(CHECK_AUTH);

    // Check if userRole is 'Investor'
    if (userRole === 'Investor') {
      // Handle investor redirection logic
      applications = await store.dispatch(FETCH_SESSIONLESS_APP_BY_APP_TYPE, 'investor');
      applications = applications.data.data.applications;
      currentUser = store.getters.currentUser;
      matchedApplication = applications.find(app => app.user_id === currentUser.id);
      application = matchedApplication ? matchedApplication : applications[0];
      currentApp = application.hash_id;
      // Redirect to investor route
      return next({ 
        name: 'sessionlessDeclaration', 
        params: { 
          appType: (application.type == 'Investor') ? application.type : 'investor',
          app_id: currentApp 
        } 
      });
    }
    // If userRole is not 'Investor', continue with the normal routing flow
  }
  // Continue with the normal routing flow
  next();
});

export default router;